<template>
  <article class="sidebar-wrapper" :class="{ 'toggle-active': menuFolding }">
    <!-- sidebar folding -->
    <div v-if="menuFolding" class="menu-folding">
      <CommonLoginAfterSideBarFolding />
    </div>
    <!-- sidebar default -->
    <div v-else class="menu-open">
      <CommonLoginSideBarDefault />
    </div>

    <!-- toggle button -->
    <button @click="menuFoldingTab" class="btn__menu--toggle">
      <img v-if="!menuFolding" :src="OpenMenuBtn" alt="" />
      <img v-else :src="FoldMenuBtn" alt="" />
    </button>
  </article>

  <!-- sidebar default -->
  <div v-if="!menuFolding" class="logout-btn open-btn">
    <button class="highlight highlight__500" @click="toFaqHandler">
      <img src="@/assets/images/layouts/sideBar/mainMenu/FAQ.svg" alt="" />
      {{ $t("menu.faq") }}
    </button>
    <!-- <button class="highlight highlight__500" v-show="false">
            <img src="@/assets/images/layouts/sideBar/mainMenu/logout.svg" alt="">
            Log out
        </button> -->
  </div>

  <!-- sidebar folding -->
  <div v-if="menuFolding" class="logout-btn folding-btn">
    <button @click="toFaqHandler">
      <img src="@/assets/images/layouts/sideBar/mainMenu/FAQ.svg" alt="" />
    </button>
    <!-- <button v-show="false">
            <img
                src="@/assets/images/layouts/sideBar/mainMenu/logout.svg"
                alt=""
            />
        </button> -->
  </div>
</template>

<script setup>
import CommonLoginAfterSideBarFolding from "@/components/common/login/after/SideBarFolding.vue";
import CommonLoginSideBarDefault from "@/components/common/login/SideBarDefault.vue";
import { onMounted, onBeforeUnmount, ref, defineEmits } from "vue";
import { useRoute, useRouter } from "vue-router";
// toggle button
import OpenMenuBtn from "@/assets/images/layouts/sideBar/btn_menu_toggle.svg";
import FoldMenuBtn from "@/assets/images/layouts/sideBar/btn_menu_toggle_fold.svg";
// import {UserInfo}  from '~/client_api/login/after_login.js'
// import { logoutHandler } from '~/client_api/user/user_api';

const route = useRoute();
const router = useRouter();
const toFaqHandler = () => {
  if (route.path.includes("mystore")) {
    window.open("https://www.risingx.co.kr/Faq?type=store", "_blank");
  } else {
    window.open("https://www.risingx.co.kr/Faq?type=user", "_blank");
  }
};
// const userStore     = useUserStore();
// const userStoreData = userStore.userData;
// const isLogined     = userStore.isLogined;
// const popupStore    = usePopupList();

// const props = defineProps({
//     userData : Object,
// });

// const userInfoData = shallowReactive({});
// userInfoData.value = new UserInfo({
//     nickName  : userStoreData.nickName,
//     email     : userStoreData.email,
//     imageUrl  : userStoreData.imageUrl,
//     subscribe : userStoreData.subscribe,
//     referrals : userStoreData.referrals,
//     wallet    : userStoreData.wallet,
//     kibotAuto : userStoreData.kibotAuto,
//     grade     : userStoreData.grade,
//     gradeIcon : userStoreData.gradeIcon,
//     userType  : userStoreData.userType
// });

const menuFolding = ref(false);

const emit = defineEmits(["menuFolding"]);

const menuFoldingTab = () => {
  menuFolding.value = !menuFolding.value;
  emit("menuFolding", menuFolding.value);
};

const handleResize = () => {
  if (window.innerWidth <= 1024) {
    menuFolding.value = false;
    emit("menuFolding", menuFolding.value);
  }
};

// watch(userStoreData, (newVal) => {
//     userInfoData.value = new UserInfo({
//         nickName  : newVal.nickName,
//         email     : newVal.email,
//         imageUrl  : newVal.imageUrl,
//         subscribe : newVal.subscribe,
//         referrals : newVal.referrals,
//         wallet    : newVal.wallet,
//         kibotAuto : newVal.kibotAuto,
//         grade     : newVal.grade,
//         gradeIcon : newVal.gradeIcon,
//         userType  : newVal.userType
//     });

//     menuFolding.value = isLogined && menuFolding.value;
//     emit("menuFolding", menuFolding.value);
// }, {deep: true})

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/after/SideBar.scss";
</style>
